function postData(that, url, params) {
    let _this = that || this
    // 图片上传路径
    let urls = 'http://glc.ilianpei.com' + url
    // let urls = 'http://lpw.ip171.lhyw.net' + url
    // let urls = 'http://lianpeiwang.ip189.lhyw.net' + url
    // let urls = url
    return new Promise((resolve, reject) => {
        _this.axios.post(urls, params, {
            headers: {
                'content-type': 'application/json'
            }
        }).then((res) => {
            resolve(res)
            if (res.data.code == 400001 || res.data.code == 400002 || res.data.code == 400003 || res.data.code == 400004) {
                this.$message.error('您未登录或登陆已过期，请重新登陆');
                window.localStorage.removeItem('pc_token');
                window.localStorage.removeItem('remembeLogin');
                window.localStorage.removeItem('level');
                window.localStorage.removeItem('ent_info');
                window.localStorage.removeItem('step');
                window.localStorage.removeItem('phone');
                window.localStorage.removeItem('aside'); // 左侧栏 信息管理 默认高亮下标
                window.localStorage.removeItem('asides'); // 左侧栏 数据查询 默认高亮下标
                window.localStorage.removeItem("e_id"); // 企业id
                this.$router.push({name: 'login'})
                return false
            } if (res.data.code == 400005) {
                this.$message.error(res.data.msg);
                window.localStorage.removeItem('pc_token');
                window.localStorage.removeItem('remembeLogin');
                window.localStorage.removeItem('level');
                window.localStorage.removeItem('ent_info');
                window.localStorage.removeItem('step');
                window.localStorage.removeItem('phone');
                window.localStorage.removeItem('aside');
                window.localStorage.removeItem('asides');
                window.localStorage.removeItem("e_id"); // 企业id
                this.$router.push({name: 'home'})
                return false
            }else if(url == '/wap/index/online/trade'){
                return false
            } else if (res.data.code != 0) {
                this.$message.error(res.data.msg)
                return false
            }
            let tokenObj = ['/home/register/phone','/home/login/phone_password','/home/login/phone_code']
            for (let i in tokenObj) {
                if (url == tokenObj[i]) {
                    window.localStorage.removeItem('pc_token')
                    window.localStorage.setItem('pc_token', res.data.data.token)
                }
            }
        }, (res) => {
            reject(res)
        });
    });
}

export default postData